<template>
    <div class="dashboard">
        <h2 class="title">API keys</h2>
        <table cellspacing="0" cellpadding="0" border="0">
            <tr>
                <td><b>Shop-ID:</b></td>
                <td>{{ siteId }}</td>
            </tr>
            <tr v-for="(dataKey, index) in apiKeyData">
                <td>
                    <b>{{ dataKey.access }} key:</b>
                </td>
                <td>{{ dataKey.key }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
import api from '../libs/api';

export default {
    props: ['config', 'rootConfig'],

    data() {
        return {
            apiKeyData: [],
            loading: false,
            siteId: 0,
        };
    },

    mounted() {
        this.setApiKeys();
        this.loadApiKeys();
    },

    computed: {
        apiKeyResource() {
            return this.$resource(
                this.rootConfig.endPoint + '/api_keys',
                {},
                {},
                { headers: this.rootConfig.headers }
            );
        },
    },

    methods: {
        setApiKeys() {
            api.init = (resource) => {
                return this.$resource(
                    this.rootConfig.endPoint + '/api_keys',
                    {},
                    {},
                    { headers: this.rootConfig.headers }
                );
            };

            api.res = api.init(this.config.resource);
        },

        loadApiKeys() {
            this.loading = true;
            this.apiKeyResource
                .get()
                .then(this.setApiKeyData)
                .catch(api.errorHandler);
        },

        getHeader(res, header) {
            if (res.headers.map[header]) {
                return parseInt(res.headers.map[header][0]);
            }
            let lowerHeader = header.toLowerCase();
            if (res.headers.map[lowerHeader]) {
                return parseInt(res.headers.map[lowerHeader][0]);
            }
            return 0;
        },

        setApiKeyData(res) {
            if (this.config.rootObject) {
                this.apiKeyData = res.body[this.config.rootObject];
            } else {
                this.apiKeyData = res.body;
            }

            this.siteId = this.apiKeyData[0].site_id;

            this.loading = false;
        },
    },
};
</script>

<style scoped>
.dashboard {
}

table tr {
    background-color: #fff;
}

table td {
    border-bottom: 1px solid #ebeef5;
    box-sizing: border-box;
    padding: 12px;
    transition: background-color 0.25s ease;
    vertical-align: middle;
}

table td b {
    text-transform: capitalize;
}

.title {
    font-size: 1.2rem;
    font-weight: normal;
    margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?370b473b